import { getContactCenterPrimaryStyles } from './variantStyles/contactCenterPrimary';
import { getContactCenterSecondaryStyles } from './variantStyles/contactCenterSecondary';
import { getMainSectionStyles } from './variantStyles/mainSection';
import { getPrimaryStyles } from './variantStyles/primary';
import { getPrimaryFilledStyles } from './variantStyles/primaryFilled';
import { getPrimaryOnSurfaceStyles } from './variantStyles/primaryOnSurface';
import { getSecondaryStyles } from './variantStyles/secondary';
import { getSecondaryFilledStyles } from './variantStyles/secondaryFilled';
import { getSecondaryMainSectionStyles } from './variantStyles/secondaryMainSection';
import { getSecondaryOnSurfaceStyles } from './variantStyles/secondaryOnSurface';
import { getTertiaryStyles } from './variantStyles/tertiary';
export const getIconButtonStyles = (FOUNDATIONS, SHADOWS) => {
    return {
        ...getPrimaryStyles(FOUNDATIONS),
        ...getPrimaryFilledStyles(FOUNDATIONS),
        ...getSecondaryStyles(FOUNDATIONS),
        ...getSecondaryFilledStyles(FOUNDATIONS, SHADOWS),
        ...getTertiaryStyles(FOUNDATIONS),
        ...getMainSectionStyles(FOUNDATIONS),
        ...getSecondaryMainSectionStyles(FOUNDATIONS),
        ...getPrimaryOnSurfaceStyles(FOUNDATIONS),
        ...getSecondaryOnSurfaceStyles(FOUNDATIONS),
        ...getContactCenterPrimaryStyles(FOUNDATIONS),
        ...getContactCenterSecondaryStyles(FOUNDATIONS),
    };
};
//# sourceMappingURL=styles.js.map